import React from 'react';
import { Button } from '../ui/button';
import { PauseIcon, PlayIcon } from 'lucide-react';
import { getIsActive, getToggleLabel, getToggleButtonClass, getToggleAction } from '../../utils/tenantHelpers';

/**
 * Tenant Toggle Button Component
 * Shows "Pasifleştir" for active tenants, "Aktifleştir" for inactive tenants
 */
export const TenantToggleButton = ({ tenant, onToggle, size = 'sm', showIcon = true, showText = true }) => {
  const isActive = getIsActive(tenant);
  const label = getToggleLabel(tenant);
  const buttonClass = getToggleButtonClass(tenant);
  const action = getToggleAction(tenant);
  
  // Debug log (remove in production or guard with env variable)
  if (process.env.NODE_ENV === 'development') {
    console.debug('TenantToggleButton', {
      id: tenant.id,
      company_name: tenant.company_name,
      isActive,
      is_active: tenant.is_active,
      status: tenant.status,
      state: tenant.state,
      calculatedLabel: label,
      calculatedAction: action
    });
  }
  
  const handleClick = () => {
    onToggle(tenant.id, action, tenant.company_name);
  };
  
  return (
    <Button
      size={size}
      variant="outline"
      className={`flex-1 ${buttonClass}`}
      onClick={handleClick}
      title={label}
    >
      {showIcon && (
        isActive ? (
          <PauseIcon className="w-4 h-4 mr-1" />
        ) : (
          <PlayIcon className="w-4 h-4 mr-1" />
        )
      )}
      {showText && label}
    </Button>
  );
};
